// @ts-nocheck

// IMPORTS
import Swiper, {
  Navigation,
  Pagination,
  EffectFade,
  Mousewheel,
} from "swiper";

export const nuestrosCorosVideoCarousel = () => {
  const element = "#nuestros-coros .carousel-container";

  const slidersContainer = document.querySelectorAll(
    element
  ) as NodeListOf<HTMLElement>;

  if (slidersContainer) {
    slidersContainer.forEach((item, index) => {
      item.classList.add(`swiper-${index}`);
      index === 0 && item.classList.add("expanded");

      item.querySelector(".carousel-title").addEventListener("click", () => {
        if (item.classList.contains("expanded")) {
          item.classList.remove("expanded");
        } else {
          slidersContainer.forEach((item) => item.classList.remove("expanded"));
          item.classList.add(`expanded`);
        }
      })

      const sliderElement = item.querySelector(".videoCarousel") as HTMLElement;

      const carousel = new Swiper(sliderElement, {
        ...swiperConfig,
        navigation: {
          nextEl: `.swiper-${index} .swiper-button-next`,
          prevEl: `.swiper-${index} .swiper-button-prev`,
        },
      });
    });
    loadVideosCoros()
  }
};

export const swiperConfig = {
  modules: [Navigation, Pagination, EffectFade, Mousewheel],
  speed: 400,
  slidesPerView: 1,
  spaceBetween: 30,
  breakpoints: {
    767: {
      slidesPerView: 2,
    },
    1024: {
      slidesPerView: 3,
    },
    1200: {
      slidesPerView: 4,
    },
  },
};



export const loadVideosCoros = () => {

// seleccionar icon, imamen y video
  const image = document.querySelector(".video-image") as HTMLElement
  const iconPlay = document.querySelector(".video-icon-play") as HTMLElement
  const player = document.querySelector("#coros-player") as HTMLIFrameElement

  const listVideos = document.querySelectorAll(".carousel-card") as NodeListOf<HTMLElement>

  const playVideo = () => {
    player.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}',"*");
    iconPlay.classList.add("hide");
    image.classList.add("hide");
  };


  if (listVideos.length) {
    // cargar video e imagen del primer item
    const firstVideo = listVideos[0].dataset.video
    const cardTitle = listVideos[0].querySelector(".carousel-card-title").textContent
    const cardDescription = listVideos[0].querySelector(".carousel-card-desc-full").textContent
    const cardImage = listVideos[0].querySelector(".carousel-card-img").getAttribute("src")
    changeVideoData({urlVideo: firstVideo, image, player, cardTitle, cardDescription, cardImage})

    // mapear items y sacar url
    listVideos.forEach(video => {

      // clic a cada item y cambiar imagen y video
      video.addEventListener("click", e => {
        const tag = e.currentTarget as HTMLElement
        const cardTitle = tag.querySelector(".carousel-card-title").textContent
        const cardDescription = tag.querySelector(".carousel-card-desc-full").textContent
        const cardImage = tag.querySelector(".carousel-card-img").getAttribute("src")
        const urlVideo = tag.dataset.video;

        changeVideoData({urlVideo, image, player, cardTitle, cardDescription, cardImage})

        iconPlay.classList.remove("hide");
        image.classList.remove("hide");
        player.parentElement.scrollIntoView({block: "center", behavior: "smooth"});
        setTimeout(() => {iconPlay.click()}, 1000)

        window.dataLayer.push({
          'event': 'trackEvent',
          'eventCategory': 'Presidente Largo Plazo 2022', // Categoría del evento (String). Requerido.
          'eventAction': 'Sección nuestros coros', // Acción o subcategoría del evento (String). Requerido.
          'eventLabel': cardTitle, // Etiqueta de descripción del evento (String). Requerido.
        });

      })
    })
  }

  if (!!image) image.addEventListener("click", playVideo);
  if (!!iconPlay) iconPlay.addEventListener("click", playVideo);

}

interface PropsVideo {
  urlVideo: string
  image: HTMLElement
  player: HTMLElement
  cardTitle: string
  cardDescription: string
  cardImage: string
}

const changeVideoData = ({urlVideo, image, player, cardTitle, cardDescription, cardImage}: PropsVideo) => {
  const title = document.querySelector(".video-caption-title") as HTMLElement
  const description = document.querySelector(".video-caption-subtitle") as HTMLElement

  const urlParams = new URL(urlVideo).searchParams.get("v");

  // const urlImage = `https://img.youtube.com/vi/${urlParams}/maxresdefault.jpg`
  const urlIframe = `https://www.youtube.com/embed/${urlParams}?enablejsapi=1`

  image.getAttribute("src") !== cardImage && image.setAttribute("src", cardImage)
  player.getAttribute("src") !== urlIframe && player.setAttribute("src", urlIframe)

  // captions
  title.textContent = cardTitle
  description.textContent = cardDescription
}
